import { PharmacyOrdersSortOrderType, SortDirection } from "@/Common/Models/UI/Enums";

class PharmacyOrdersTableSettingsModel {
    public currentPageNumber: number = 1;
    public searchText: string = "";
    public queryOrderType: PharmacyOrdersSortOrderType = PharmacyOrdersSortOrderType.PreferredDate;
    public queryOrderDirection: SortDirection = SortDirection.DESC;

    constructor(init?: Partial<PharmacyOrdersTableSettingsModel>) {
        Object.assign(this, init);
    }
}

export { PharmacyOrdersTableSettingsModel };
